module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jRxMV"))).then(() => module.bundle.root('hEqeo'));